<div class="content-layout" [class.no-gap]="noGap">
  <div class="content-width" [style.max-width.px]="maxWidth">
    <div class="filters">
      <ng-content select="lomt-filters"></ng-content>
    </div>
    <ng-content></ng-content>
  </div>
  <ng-content select="lomt-metadata"></ng-content>
</div>
